export function CommunityGuidelines() {
  return (
    <div className="markdown">
      <p>
        These Community Guidelines (&quot;<strong>Guidelines</strong>&quot;) are
        designed to foster a positive, respectful, and safe environment for
        everyone who uses our Services. These Guidelines are governed by and
        part of our Terms of Service. You agree to follow these Guidelines in
        all use of the Services. We may update these Guidelines from time to
        time. We will notify you of any changes by posting the updated
        Guidelines on our website or through the Service. Your continued use of
        the Service after the changes take effect constitutes your acceptance of
        the revised Guidelines.{" "}
      </p>
      <p>
        If you have any questions about these Guidelines, please contact us at{" "}
        <a href="mailto:hello@graze.social">hello@graze.social</a>.
      </p>
      <ol>
        <li>
          <p>
            <strong>BE RESPECTFUL</strong>{" "}
          </p>
          <ul>
            <li>
              Treat all users with kindness and respect, whether in Graze’s
              Discord, on the Graze platform, or in the construction of your
              feeds.
            </li>
            <li>
              Do not engage in harassment, bullying, hate speech, or
              discrimination based on race, ethnicity, religion, gender, sexual
              orientation, disability, or other protected characteristics.
            </li>
            <li>Avoid personal attacks, insults, or inflammatory language.</li>
          </ul>
        </li>
        <li>
          <p>
            <strong>CREATE AND SHARE RESPONSIBLY</strong>{" "}
          </p>
          <p>
            Graze allows Users to customize their Bluesky feeds in any way they
            choose. That said, we do not allow Graze to be used to create feeds
            or display Bluesky content that:
          </p>
          <ul>
            <li>
              <p>
                Violates applicable law or regulation (e.g., copyright or
                trademark infringement, defamation, or fraudulent practices).
              </p>
            </li>
            <li>
              <p>
                Is illegal, harmful, abusive, defamatory, harassing, or
                discriminatory or promotes activity of a similar nature.
              </p>
            </li>
            <li>
              <p>
                Exploits or endangers minors or other human beings or that
                infringes on the legal rights of others.
              </p>
            </li>
            <li>
              <p>
                Contains or disseminates malware, viruses, or other harmful
                code.
              </p>
            </li>
            <li>
              <p>
                Contains or promotes violence, hate speech, or illegal activity.
              </p>
            </li>
            <li>
              <p>
                Spreads false or misleading information that could harm
                individuals or the public, including misinformation about
                health, safety, or elections.
              </p>
            </li>
            <li>
              <p>
                Is spam or that is repetitive, irrelevant, or unsolicited or
                that is intended to manipulate or deceive others.
              </p>
            </li>
            <li>
              <p>
                Graze otherwise determines, in our sole discretion, to be
                inappropriate, disruptive, disparaging or potentially harmful to
                any party.{" "}
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <strong>ADVERTISE RESPONSIBLY</strong>{" "}
          </p>
          <p>Users that use the Services for advertising must:</p>
          <ul>
            <li>
              <p>
                Provide accurate and truthful information about their products
                or services;
              </p>
            </li>
            <li>
              <p>
                Clearly disclose that the content is a sponsored or paid
                promotion in compliance with applicable advertising regulations
                and practices;
              </p>
            </li>
            <li>
              <p>
                Not engage in deceptive, fraudulent, or misleading practices.
              </p>
            </li>
          </ul>
          <p>Graze does not permit the promotion of:</p>
          <ul>
            <li>
              <p>Illegal products or services;</p>
            </li>
            <li>
              <p>Harmful or deceptive practices;</p>
            </li>
            <li>
              <p>
                Content that exploits vulnerable populations (such as children,
                the elderly, individuals in crisis, or marginalized groups).
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <strong>REPORT VIOLATIONS</strong>
          </p>
          <p>
            Users must promptly report content or behavior that violates these
            Guidelines to{" "}
            <a href="mailto:legal@graze.social">legal@graze.social</a>. Please
            include as much detail as possible, such as:
          </p>
          <ul>
            <li>
              <p>A description of the violating feed or behavior;</p>
            </li>
            <li>
              <p>The username or account associated with the violation; and</p>
            </li>
            <li>
              <p>The location of the content within the Services.</p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <strong>ENFORCEMENT</strong>{" "}
          </p>
          <p>
            Failure to follow these Guidelines may result in feed removal,
            account suspension, or termination of your access to the Services at
            our sole discretion.
          </p>
          <ul>
            <li>
              Graze has the right but no obligation to review, remove, or
              restrict any feed or content that violates these Guidelines. We
              may use automated tools, human moderators, or user reports to
              identify and address violations. We may also consider User
              behavior on Bluesky or other platforms (such as our third-party
              payment processors) when determining whether these Guidelines have
              been violated.{" "}
            </li>
            <li>
              Repeated or severe violations of these Guidelines may result in
              the suspension or termination of the User’s account at our sole
              discretion. Graze may also report illegal activity to law
              enforcement or regulatory authorities.{" "}
            </li>
            <li>
              Additionally, Graze reserves the right to remove any feed or
              sponsored content that violates Section 3 of Guidelines or that is
              deemed illegal, inappropriate, or harmful. Graze may (i) remove
              the ability to earn revenue from the content; (ii) suspend or
              terminate the User’s access or account; and/or (iii) refuse to
              display the content through the Services.{" "}
            </li>
            <li>
              If your content is removed or your account is suspended, you may
              appeal the decision by contacting us at{" "}
              <a href="mailto:legal@graze.social">legal@graze.social</a>.
              Provide a detailed explanation of why you believe the action was
              incorrect, along with any supporting evidence.
            </li>
          </ul>
          <p>
            Graze shall have no liability to the User or any other party
            whatsoever as the result of actions taken to enforce these
            Guidelines.
          </p>
        </li>
      </ol>
    </div>
  );
}
